<template>
  <div>
    <div class="form-wrap">
      <div class="form-list py-2">

        <!-- 補足説明-->
        <div class="row form-description-area">

          <p class="col-12 px-4"><trans-text i18nKey="ui[3][2]" :replaceData="{email:email}" :isHtml="true"/></p>
          <p class="col-12 px-4 text-danger"><i class="fa fa-asterisk" aria-hidden="true"></i> <trans-text i18nKey="ui[3][3]" :isHtml="true"/></p>
          <p class="col-12 px-4"><trans-text i18nKey="ui[3][4]" :isHtml="true"/></p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.confirmation_code.$error}">
          <label class="col-6 col-form-label"><trans-text i18nKey="ui[3][5]"/></label>
          <div class="col-6">
            <input class="form-control transparent-input" type="text" value="" placeholder="123456" v-model="input.confirmation_code" @change="$v.input.confirmation_code.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.confirmation_code" type="required"><i class="fa fa-asterisk" aria-hidden="true"></i> <trans-text i18nKey="error[3][1]"/></input-feedback>
            <input-feedback :validate-for-input="$v.input.confirmation_code" type="number"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[3][2]"/></input-feedback>
            <input-feedback :validate-for-input="$v.input.confirmation_code" type="numberLength"><i class="fa fa-asterisk" aria-hidden="true"></i> <trans-text i18nKey="error[3][3]"/></input-feedback>
          </p>
        </div>
      </div>
    </div>

    <!-- フォーム送信UI -->
    <div class="row text-center">
      <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
        <div class="my-4">
          <button type="button" class="btn w-100 btn-lg btn-warning" @click="tryForm"><trans-text i18nKey="ui[3][6]"/></button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,between,number,numberLength,email} from 'systems/validators'

  export default {
    extends:FormPartialBase,
    components: {
    },
    props:{
      user:Object,
    },
    data () {
      return {
        input: {
          confirmation_code: "",
        }
      }
    },
    validations: {
      input: {
        confirmation_code: {
          required,
          number,
          numberLength: numberLength(5)
        },
      },
    },
    computed:{
      email(){
        return this.$route.query.email || this.user.email || this.$t('ui[3][91]')
      }
    },
    methods:{
      tryForm(e){
        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }
        this.$emit('tryForm', this.input)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// PageForm.vue?40200d0e